const state = {
  navbarState: "0",
  pageName: "차트",
  email: null,
  name: null,
  role: null,
  isLogin: false,
  isAdmin: false,
  lnbVisible: false,
  gnbVisible: false,
  footerVisible: false,
  artistList: [],
  apiList: [],
  channelList: [],
  contentsList: [],
  userList: [],
  clientList: [],
  codeList: [],
  projectList: [],
  artist: {
    artist_id: null,
  },
  menu: "",
  service: "",
  contractorList: [],
  contractList: [],
  albumList: [],
  songList: [],
  contractListByContractor: [],
  sidebarCollapsed: false,
};

export default state;
